import MuiAppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import * as React from 'react';

import { AnonymousInfo } from '@/components/layout/AppBar/AnonymousInfo';
import { AppHeader } from '@/components/layout/AppBar/AppHeader';
import { UserAccountInfo } from '@/components/layout/AppBar/UserAccountInfo';
import { isAuthUserRouteExclude } from '@/helpers/isAuthUserRouteExclude';
import { useAuth } from '@/hooks/useAuth';

interface AppBarProps {}

export const AppBar: React.FC<AppBarProps> = () => {
  const { userAuthenticated } = useAuth();
  const { pathname } = location;
  const authenticated = userAuthenticated && !isAuthUserRouteExclude(pathname);

  return (
    <>
      <MuiAppBar position="static">
        <Container
          maxWidth={false}
          sx={{
            paddingLeft: '8px',
            paddingRight: '8px',
          }}
        >
          <Toolbar disableGutters>
            <AppHeader />
            {authenticated && <UserAccountInfo />}
            {!authenticated && <AnonymousInfo />}
          </Toolbar>
        </Container>
      </MuiAppBar>
    </>
  );
};
